module.exports = __webpack_public_path__ + "static/media/midnight-instagram.2a07ed90.svg";